var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "59px",
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Abstract/03",
    transform: "translate(-3.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EEBAD4",
    x: 3,
    y: 19.1538462,
    width: 58.1538462,
    height: 22.6153846,
    className: "fill-dynamic-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.443787,61.1538462 C50.7443077,61.1538462 47.7337278,58.1432663 47.7337278,54.443787 L47.7337278,9.71005917 C47.7337278,7.24299408 45.7274201,5.23668639 43.260355,5.23668639 C40.7932899,5.23668639 38.7869822,7.24299408 38.7869822,9.71005917 L38.7869822,54.443787 C38.7869822,58.1432663 35.7764024,61.1538462 32.0769231,61.1538462 C28.3774438,61.1538462 25.3668639,58.1432663 25.3668639,54.443787 L25.3668639,28.7218935 C25.3668639,26.2548284 23.3605562,24.2485207 20.8934911,24.2485207 C18.426426,24.2485207 16.4201183,26.2548284 16.4201183,28.7218935 L16.4201183,54.443787 C16.4201183,58.1432663 13.4095385,61.1538462 9.71005917,61.1538462 C6.01057988,61.1538462 3,58.1432663 3,54.443787 L3,47.7337278 L5.23668639,47.7337278 L5.23668639,54.443787 C5.23668639,56.9108521 7.24299408,58.9171598 9.71005917,58.9171598 C12.1771243,58.9171598 14.183432,56.9108521 14.183432,54.443787 L14.183432,28.7218935 C14.183432,25.0224142 17.1940118,22.0118343 20.8934911,22.0118343 C24.5929704,22.0118343 27.6035503,25.0224142 27.6035503,28.7218935 L27.6035503,54.443787 C27.6035503,56.9108521 29.609858,58.9171598 32.0769231,58.9171598 C34.5439882,58.9171598 36.5502959,56.9108521 36.5502959,54.443787 L36.5502959,9.71005917 C36.5502959,6.01057988 39.5608757,3 43.260355,3 C46.9598343,3 49.9704142,6.01057988 49.9704142,9.71005917 L49.9704142,54.443787 C49.9704142,56.9108521 51.9767219,58.9171598 54.443787,58.9171598 C56.9108521,58.9171598 58.9171598,56.9108521 58.9171598,54.443787 L58.9171598,47.7337278 L61.1538462,47.7337278 L61.1538462,54.443787 C61.1538462,58.1432663 58.1432663,61.1538462 54.443787,61.1538462",
    id: "Fill-1",
    className: "icon-color-base"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon03.29b0b8d56ad4ea5643e4742537ea273d.svg";
export { ForwardRef as ReactComponent };